var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function Divider() {
    return (_jsx("div", __assign({ className: "hidden sm:block", "aria-hidden": "true" }, { children: _jsx("div", __assign({ className: "py-5" }, { children: _jsx("div", { className: "border-t border-gray-200" }, void 0) }), void 0) }), void 0));
}
export default Divider;
